import { AuthenticationDetails, } from 'amazon-cognito-identity-js';
export const passwordRules = {
    specialChar: /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]/,
    upperCase: /[A-Z]/,
    lowerCase: /[a-z]/,
    digit: /[0-9]/,
    minLength: /.{10,}/,
};
export async function logIn(args) {
    const authenticationDetails = new AuthenticationDetails({
        Username: args.cognitoUser.getUsername(),
        Password: args.password,
    });
    return new Promise((resolve, reject) => {
        args.cognitoUser.authenticateUser(authenticationDetails, {
            onFailure: reject,
            onSuccess: () => {
                args.onCognitoUserChanged(args.cognitoUser);
                resolve({ type: 'success' });
            },
            newPasswordRequired: (_, newPasswordAttributes) => {
                resolve({
                    type: 'newPasswordRequired',
                    newPasswordAttributes,
                    user: args.cognitoUser,
                });
            },
        });
    });
}
export async function getAccessToken(args) {
    try {
        let session = await new Promise((resolve, reject) => {
            // TRICKY: getSession might refresh token
            args.cognitoUser.getSession((error, result) => {
                if (error) {
                    reject(error);
                }
                else {
                    resolve(result);
                }
            });
        });
        if (args.forceRefresh) {
            session = await new Promise((resolve, reject) => {
                args.cognitoUser.refreshSession(session.getRefreshToken(), (error, session) => {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(session);
                    }
                });
            });
        }
        return session.getAccessToken();
    }
    catch (error) {
        args.onCognitoUserChanged(null);
        throw error;
    }
}
